import { ReactComponent as ArrowIcon } from "src/images/downArrow.svg";
import styled, { css } from "styled-components";
import ButtonBordered from "src/components/shared/Button/ButtonBordered";
import { media } from "src/styles/mixins";

export const InGameNavDropdownWrapper = styled.div`
  width: 100%;
  position: relative;

  &:not(:first-child) {
    margin-top: 20px;
  }

  @media ${({ theme }) => theme.mq.md} {
    width: auto;

    &:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const InGameNavDropdownButton = styled.button`
  display: flex;
  align-items: center;

  position: relative;

  cursor: pointer;

  width: 100%;
  height: 56px;

  background-color: ${({ theme }) => theme.colors.background};

  border: none;
  outline: none;

  font-size: ${({ theme }) => theme.fonts.sizes.xs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};

  svg {
    width: 24px;
    height: 24px;
  }

  svg:first-child {
    margin-right: 16px;
  }

  svg:last-child {
    margin-left: auto;
    transform: rotate(-90deg);
  }

  &::after {
    content: "";
    position: absolute;
    right: -16px;
    bottom: 0;
    width: 100vw;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.navTabBorder};
  }

  @media ${({ theme }) => theme.mq.md} {
    height: 100%;
    margin-right: 48px;

    border: none;

    font-size: ${({ theme }) => theme.fonts.sizes.base};

    svg {
      height: 32px;
      width: 32px;
    }

    svg:first-child {
      margin-right: 15px;
    }

    svg:last-child {
      margin-left: 18px;
      transform: rotate(0);
    }

    &::after {
      content: none;
    }
  }
`;

const GameActionButtonCss = css`
  width: 296px;
  margin-top: 72px;

  &:not(:first-of-type) {
    margin-top: 36px;
  }

  ${media.up("LAPTOP")`
    margin-top: 0;
    width: 208px;
    &:not(:first-of-type) {
      margin-top: 0;
    }
    &:not(:last-child) {
      margin-right: 48px;
    }
  `}
`;

export const BorderedGameActionButton = styled(ButtonBordered)`
  ${GameActionButtonCss}
`;

export const StyledArrowIcon = styled(ArrowIcon)<{ $isTabVisible: boolean }>`
  ${({ $isTabVisible, theme }) =>
    $isTabVisible &&
    css`
      @media ${theme.mq.md} {
        transform: rotate(180deg) !important;
      }
    `}
`;
